export class WKTValue{constructor(i){this._position=void 0;this._position=i}getPosition(){return this._position}}